var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlimming(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.71,
    height: 29.226,
    viewBox: "0 0 28.71 29.226",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1749",
    "data-name": "Group 1749",
    transform: "translate(-247.75 6.25)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3999",
    "data-name": "Path 3999",
    d: "M315.661,9.169a14.318,14.318,0,0,0-1.433-4l-.005-.01c-.257-.509-.524-1-.783-1.481a11.375,11.375,0,0,1-1.708-4.38c-.142-3.054,1.178-4.26,1.231-4.306a.554.554,0,0,0,.169-.62A.564.564,0,0,0,312.6-6H295.782a.564.564,0,0,0-.535.367.55.55,0,0,0,.167.618c.056.05,1.377,1.256,1.235,4.309a11.384,11.384,0,0,1-1.708,4.381c-.26.479-.527.972-.784,1.481l-.005.01a13.876,13.876,0,0,0-1.476,4.278c0,.016,0,.031-.006.047a8.741,8.741,0,0,0-.066,1.765,23.659,23.659,0,0,0,.526,3.485.561.561,0,0,0,1.1-.241,22.593,22.593,0,0,1-.5-3.318c-.012-.189-.017-.377-.015-.562l7.977,6.129a3.77,3.77,0,0,0,1.943.736V21.6h-7.154c-.206-.507-.612-1.542-1.048-2.842a.561.561,0,0,0-1.064.357c.638,1.9,1.2,3.212,1.221,3.267a.561.561,0,0,0,.516.34h16.181a.561.561,0,0,0,.516-.34c.108-.253,2.659-6.252,2.979-11.13a8.832,8.832,0,0,0-.11-2.056c0-.01,0-.02-.005-.031ZM297.77-.653a7.688,7.688,0,0,0-.868-4.224h14.575a7.686,7.686,0,0,0-.868,4.224,12.088,12.088,0,0,0,1.842,4.863c.189.349.38.7.565,1.055a15.435,15.435,0,0,1-8.827,2.379,15.435,15.435,0,0,1-8.827-2.379c.185-.354.376-.706.565-1.055A12.081,12.081,0,0,0,297.77-.653ZM293.833,9.3a12.053,12.053,0,0,1,1.022-3.019,16.783,16.783,0,0,0,9.334,2.485,16.784,16.784,0,0,0,9.334-2.485,12.485,12.485,0,0,1,.971,2.757l-8.945,6.873a2.8,2.8,0,0,1-3.181-.051Zm20.822,1.882a39.348,39.348,0,0,1-2.75,10.422h-7.154V17.438a3.443,3.443,0,0,0,1.483-.638l8.428-6.476a7.533,7.533,0,0,1-.006.858Zm0,0",
    transform: "translate(-42.085)",
    fill: "#1c9d87",
    stroke: "#1c9d87",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4000",
    "data-name": "Path 4000",
    d: "M489.967,143.006a.561.561,0,0,0,.561-.561v-1.708a.561.561,0,1,0-1.122,0v1.708a.561.561,0,0,0,.561.561Zm0,0",
    transform: "translate(-227.862 -137.975)",
    fill: "#1c9d87",
    stroke: "#1c9d87",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4001",
    "data-name": "Path 4001",
    d: "M251.138,46.854a.561.561,0,1,0,.793.793l1.626-1.626a.558.558,0,0,0,0-.794L251.931,43.6a.561.561,0,1,0-.793.794l.669.669h-3.246a.561.561,0,1,0,0,1.122h3.246Zm0,0",
    transform: "translate(0 -46.663)",
    fill: "#1c9d87",
    stroke: "#1c9d87",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4002",
    "data-name": "Path 4002",
    d: "M653.938,45.063h-3.246l.669-.669a.561.561,0,1,0-.793-.794l-1.627,1.627a.568.568,0,0,0-.132.591.606.606,0,0,0,.132.2l1.627,1.627a.561.561,0,0,0,.793-.793l-.669-.669h3.246a.561.561,0,1,0,0-1.122Zm0,0",
    transform: "translate(-378.289 -46.663)",
    fill: "#1c9d87",
    stroke: "#1c9d87",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4003",
    "data-name": "Path 4003",
    d: "M312.985,390.873a.561.561,0,1,0-.561.561.562.562,0,0,0,.561-.561Zm0,0",
    transform: "translate(-60.28 -374.077)",
    fill: "#1c9d87",
    stroke: "#1c9d87",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlimming);
export default __webpack_public_path__ + "static/media/slimming.39eab4dfaed91d82be480498d5dbca4e.svg";
export { ForwardRef as ReactComponent };